var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWeatherThunderstorm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.3 13.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1 {\n        stroke-linejoin: round;\n      }\n\n      .st0, .st1, .st2 {\n        fill: none;\n        stroke: #02222b;\n        stroke-linecap: round;\n      }\n\n      .st1 {\n        stroke-width: .8px;\n      }\n\n      .st2 {\n        stroke-miterlimit: 10;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M10.4,8.9h.4c1.6,0,2.7-1.4,2.7-3s-1.3-3-3-3-.4,0-.6,0c-.3-1.3-1.5-2.2-2.9-2.2s-2.6,1-2.9,2.2c-.1,0-.3,0-.4,0-1.7,0-3,1.3-3,3s1,2.7,2.4,2.9c.2,0,.1,0,.3,0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 9.8,
    y1: 11.1,
    x2: 9.8,
    y2: 12.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11.6,
    y1: 11.1,
    x2: 11.6,
    y2: 12.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 3.7,
    y1: 11.1,
    x2: 3.7,
    y2: 12.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1.9,
    y1: 11.1,
    x2: 1.9,
    y2: 12.6
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "6.1 5.5 8.2 5.5 7.3 8.4 8.8 8.4 5.8 12.9 6.4 9.2 5.1 9.2 6.1 5.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherThunderstorm);
export default __webpack_public_path__ + "static/media/icon_weather_thunderstorm.465aee9c5e921e55a67f70e7543d6be3.svg";
export { ForwardRef as ReactComponent };